var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSodar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11443 3.07715C1.79639 3.07715 1.53857 3.33787 1.53857 3.65949C1.53857 3.72382 1.59014 3.77596 1.65375 3.77596H1.76892L4.41786 12.744H12.1919L14.7833 3.77596H14.8985C14.9621 3.77596 15.0136 3.72382 15.0136 3.65949C15.0136 3.33787 14.7558 3.07715 14.4378 3.07715H2.11443Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46826 12.7441H12.3775V15.6735H4.46826V12.7441Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5775 10.2809H12.5685C12.4254 8.26039 10.6103 6.68574 8.4229 6.68574C6.2355 6.68574 4.42042 8.26039 4.27734 10.2809H4.26826V10.4809V15.6738V15.8738H4.46826H12.3775H12.5775V15.6738V10.4809V10.2809ZM11.8282 10.4898L11.8286 10.5139V15.1314H5.0172V10.5138L5.0176 10.4898C5.04517 8.82744 6.52528 7.42814 8.4229 7.42814C10.3205 7.42814 11.8006 8.82744 11.8282 10.4898Z",
    fill: "#1E2447",
    stroke: "#1E2447",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88184 15.6494C3.88184 15.582 3.93584 15.5273 4.00246 15.5273H5.63945H5.81177H10.7572H10.9123H12.825C12.9011 15.5273 12.9629 15.582 12.9629 15.6494V16.87C12.9629 16.9374 12.9011 16.992 12.825 16.992H10.7572C10.6811 16.992 10.6194 16.9374 10.6194 16.87V16.4062H5.93239V16.87C5.93239 16.9374 5.87839 16.992 5.81177 16.992H4.00246C3.93584 16.992 3.88184 16.9374 3.88184 16.87V15.6494Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0957 8.57911C13.0636 8.52355 13.0826 8.45251 13.1382 8.42044L13.5406 8.18813C13.5961 8.15606 13.6672 8.17509 13.6992 8.23065L18.4034 16.3786C18.4355 16.4342 18.4165 16.5052 18.3609 16.5373L17.9586 16.7696C17.903 16.8017 17.832 16.7826 17.7999 16.7271L13.0957 8.57911Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSodar);
export default __webpack_public_path__ + "static/media/sodar.ca91f635.svg";
export { ForwardRef as ReactComponent };